{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.axams.softline",
  "name": "LH Axams Softline"
}
